import { useMutation, useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'

export type ReminderChannel = 'sms' | 'email' | 'push'

export interface ReminderPreview {
  originalAudience: number
  completed: number
  reminderAudience: number
  previousChannels: ReminderChannel[]
  previousChannelsLabel: string | null
  defaultMessage: string
  blockedMessage: string | null
}

export function useReminderPreview(instrumentId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['instrument-reminder-preview', instrumentId],
    enabled: enabled && instrumentId.length > 0,
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<ReminderPreview>>(
        `/api/v1/instruments/${instrumentId}/reminder-preview`,
      )
      return data.data
    },
  })
}

export function useSendReminder(instrumentId: string) {
  return useMutation({
    mutationFn: async (input: { channels: ReminderChannel[]; message: string }) => {
      const { data } = await apiClient.post<ApiResponse<{ queued: boolean }>>(
        `/api/v1/instruments/${instrumentId}/reminders`,
        input,
        { headers: { 'Idempotency-Key': crypto.randomUUID() } },
      )
      return data.data
    },
  })
}
